interface ICardNumberProps {
  logo: string;
  cardNumber: string;
  cardShabaNumber: string;
}

const CardNumberItem = ({
  logo,
  cardNumber,
  cardShabaNumber,
}: ICardNumberProps) => {
  const numbers = cardNumber?.split(' ');

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col">
        <p className="text-sm font-medium text-neutral-600">
          شماره کارت شرکت آینده پژوهان لوتوس
        </p>
        <div className="flex items-center gap-1 p-2 border border-gray-100 border-solid shadow-sm shadow-gray-100 rounded-xl">
          {logo && (
            <img
              src={logo}
              alt="bank-logo"
              className="border border-gray-300 rounded-full w-7 h-7"
            />
          )}
          <div className="flex flex-row-reverse gap-4 mx-2">
            {numbers?.map((number, index) => (
              <span
                className="text-lg font-medium text-neutral-600"
                key={index}
              >
                {number}
              </span>
            ))}
          </div>
        </div>
      </div>
      {Boolean(cardShabaNumber) && (
        <div className="flex flex-col">
          <p className="mt-8 font-medium text-gray-900 text-md">
            شماره شبا شرکت آینده پژوهان لوتوس
          </p>
          <div className="flex items-center gap-1 p-2 border border-gray-100 border-solid shadow-sm shadow-gray-100 rounded-xl">
            {logo && <img src={logo} alt="bank-logo" className="w-6 mr-3" />}
            <div className="flex flex-row-reverse gap-4">
              <span>{cardShabaNumber}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CardNumberItem;
